import Message from '@/models/Message'
import DataService from '@/services/DataService'
import { useDefaultStore } from '@/store'
import { getAuth, sendPasswordResetEmail, signInWithEmailAndPassword } from 'firebase/auth'

class AuthService {
  private get store() {
    return useDefaultStore()
  }

  init() {
    getAuth().onAuthStateChanged(async (user) => {
      try {
        if (user?.email) {
          // signed in to firebase user
          this.store.signingIn = true // set state on restore after reload if signed in
          await Promise.all([DataService.loadUserData(user.email), DataService.loadTranslations()])
        } else {
          this.store.currentUser = null
        }
      } catch (err: any) {
        console.error(err)
        this.store.currentUser = null
        this.store.addMessage(new Message('Ett fel har inträffat', err || 'Servern kunde inte nås. Försök igen om en liten stund.', 'danger'))
      } finally {
        this.store.signingIn = false
      }
    })
  }

  async signIn(username: string, password: string) {
    try {
      this.store.signingIn = true
      await getAuth().signOut() // make sure to trigger authStateChange
      await signInWithEmailAndPassword(getAuth(), username, password)
      this.store.messages = []
    } catch (err: any) {
      this.store.addMessage(new Message('Inloggning misslyckades', String(err.message), 'danger'))
      this.signOut()
    }
  }

  private async signOut() {
    this.store.signingIn = false
    DataService.unsubAllFirebaseObservers()
    await getAuth().signOut()
  }

  async signOutWithMessage() {
    await this.signOut()
    this.store.addMessage(new Message('Du har blivit utloggad', undefined, 'success', 5))
  }

  async forgotPassword(email: string): Promise<Message | void> {
    try {
      await sendPasswordResetEmail(getAuth(), email)
      this.store.addMessage(new Message('Glömt lösenord', 'Ett e-mail med instruktioner om hur du återställer ditt lösenord har skickats.'))
    } catch (err) {
      this.store.addMessage(new Message('Glömt lösenord', String(err), 'danger'))
    }
  }

  async getUserToken() {
    return getAuth().currentUser?.getIdToken()
  }
}
export default new AuthService()
